<template>
  <div class="container-padding px-5">
    <h3 class="font-medium text-xl">
      <FontAwesomeIcon :icon="faBullhorn" class="mr-2" />
      <span>Tell us what you think</span>
    </h3>

    <p>Provide anonymous feedback to the seller</p>

    <UtilMessage v-if="isComplete" type="success" class="mt-2">
      Thank you for providing feedback
    </UtilMessage>

    <div v-else class="relative mt-2">
      <transition name="fade" mode="out-in">
        <div :key="currentQuestionIndex" class="relative top-0">
          <p class="italic text-lg">{{ questions[currentQuestionIndex].title }}</p>

          <div>
            <UtilButton
              @click="sendFeedback(1)"
              textLink
              class="text-green-600 hover:text-green-900 font-medium pb-0"
            >
              <FontAwesomeIcon :icon="faThumbsUp" class="mr-1" />
              <span>{{ $t('feedback.yes') }}</span>
            </UtilButton>

            <UtilButton
              @click="sendFeedback(0)"
              textLink
              class="text-red-600 hover:text-red-900 ml-6 font-medium pb-0"
            >
              <FontAwesomeIcon :icon="faThumbsDown" class="mr-1" />
              <span>{{ $t('feedback.no') }}</span>
            </UtilButton>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { faThumbsUp, faThumbsDown, faBullhorn } from '@fortawesome/pro-regular-svg-icons'
import LegacyApi from '@/lib/api/legacy'
import UtilButton from '@/components/utils/UtilButton'
import UtilMessage from '@/components/utils/UtilMessage'

export default {
  name: 'WidgetListingFeedback',
  components: {
    UtilButton,
    UtilMessage
  },
  props: {
    listingRef: String
  },
  data() {
    return {
      isComplete: false,
      currentQuestionIndex: 0,
      questions: [
        {
          title: 'Is this listing priced reasonably?',
          type: 'price',
          // We attach the api to each question so we can answer in quick succession
          // without waiting for the response of the previous question
          feedbackApi: new LegacyApi()
        },
        {
          title: 'Is there enough information provided?',
          type: 'info',
          feedbackApi: new LegacyApi()
        },
        {
          title: 'Are the photos provided sufficient?',
          type: 'images',
          feedbackApi: new LegacyApi()
        }
      ],
      faThumbsUp,
      faThumbsDown,
      faBullhorn
    }
  },
  methods: {
    sendFeedback(feedbackValue) {
      this.questions[this.currentQuestionIndex].feedbackApi.post('feedback.save', {
        listingRef: this.listingRef,
        type: this.questions[this.currentQuestionIndex].type,
        feedback: feedbackValue
      })

      // Don't wait for a response just show the next question

      // Have we answered all questions?
      if (this.currentQuestionIndex + 1 >= this.questions.length) {
        this.isComplete = true
        return
      }

      this.currentQuestionIndex++
    }
  }
}
</script>
